import { createJSONStorage, persist } from "zustand/middleware";

import { create } from "zustand";

export const useBulkActionStore = create(
  persist(
    (set) => ({
      bulkIds: [],
      bulkObjs: [],
      showCheck: false,
      readyForBulkAction: false,
      activateBulkAction: false,
      savedVisitorsObjects: [],
    }),
    {
      name: "bulkData",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export function setShowCheckFalse() {
  return useBulkActionStore.setState({ showCheck: false });
}

export function setShowCheckTrue() {
  return useBulkActionStore.setState({ showCheck: true });
}

export function getActivationBulkActionStatus() {
  return useBulkActionStore.getState().activateBulkAction;
}

export function setBulkActionReady() {
  return useBulkActionStore.setState({
    readyForBulkAction: true,
  });
}

export function setBulkActionNotReady() {
  return useBulkActionStore.setState({
    readyForBulkAction: false,
  });
}
